import { QueryHookOptions, useQuery } from '@apollo/client';
import getFleetsQuery from './managedFleetsQuery.graphql';

export const useManagedFleetsQuery = (
  options: QueryHookOptions<ManagedFleetsQuery, ManagedFleetsQueryVariables>,
) => {
  return useQuery<ManagedFleetsQuery, ManagedFleetsQueryVariables>(
    getFleetsQuery,
    options,
  );
};
